import React, {useCallback} from 'react';
import {Dialog, DialogContent, DialogTitle} from '@material-ui/core';
import {withStyles} from '@material-ui/core/styles';
import {compose} from 'redux';
import {connect} from 'react-redux';
import {setContactUsDialogMessage} from '../../actions';
import {useTranslation} from 'react-i18next';
import * as _ from 'lodash';
import MoveToPlanButton from "../Button/MoveToPlanButton";

interface DialogProps {
    open: boolean;
    handleClose: () => void;
}

interface InnerProps extends DialogProps {
    classes: Record<string, string>;
    setContactUsDialogMessageAction: (value: string | null) => void;
    message: string;
}

const styles = {
    dialog: {
        textAlign: 'center',
    },
    content: {
        textAlign: 'left',
    },
    button: {
        marginTop: '16px',
        width: '100%',
        maxWidth: '250px',
    },
};

const ContactUsDialog: React.FunctionComponent<InnerProps> = ({
    open,
    handleClose,
    classes,
    setContactUsDialogMessageAction,
    message,
}: InnerProps) => {
    const contactUsClick = useCallback(() => {
        setContactUsDialogMessageAction('');
    }, [setContactUsDialogMessageAction]);

    const {t: translate} = useTranslation();

    return (
        <Dialog
            open={open}
            fullWidth={true}
            maxWidth="sm"
            onClose={handleClose}
            className={classes.dialog}
        >
            <DialogTitle>{translate('common.contactUsDialogTitle')}</DialogTitle>
            <DialogContent>
                <div className={classes.content} style={{whiteSpace: 'pre-line'}}>
                    {message}
                </div>
                <MoveToPlanButton
                    onClick={contactUsClick}
                    className={classes.button}
                    label='common.choosePlan'
                />
            </DialogContent>
        </Dialog>
    );
};

const mapStateToProps = (state: Record<string, any>): {message: string} => ({
    message: _.get(state, 'settings.contactUsDialogMessage', ''),
});

// @ts-ignore
export default compose(
    connect(
        mapStateToProps, {
            setContactUsDialogMessageAction: setContactUsDialogMessage,
        },
    ),
    // @ts-ignore
    withStyles(styles),
)(ContactUsDialog);